import React, { FC, useEffect, useState } from 'react';
import { Card, Row, Col, Empty } from 'antd';
import { GetDetailImageResponse, ImageAlbum } from 'types';
import { Skeleton } from 'antd';
import { iconPhoto } from '../../../../../assets';
import { CardGraft } from './styles';

interface Props {
  detailImage: GetDetailImageResponse | null;
  image: ImageAlbum | null | undefined;
  dataSite: string | undefined;
  formik: string;
}

const CardGraftDrop: FC<Props> = ({ detailImage, formik, dataSite, image }) => {
  const [convertImage, setConvertImage] = useState<string>('');
  const [loading, setLoading] = useState(true);

  const getBase64FromUrl = async (url: '' | undefined | string) => {
    try {
      if (url) {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
          };
        });
      }
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    const f = async () => {
      const convertItemImage =
        image?.image_url &&
        image?.image_url.replace(
          process.env.REACT_APP_S3_RES_URL || '',
          process.env.REACT_APP_RES_URL || ''
        );
      const imgBase: any = await getBase64FromUrl(convertItemImage);
      imgBase && setConvertImage(imgBase);
      setLoading(!imgBase);
    };
    f();
  }, [image]);

  return (
    <CardGraft>
      <Card bordered={false} style={{ width: 210 }}>
        <Row>
          <div className="title-name">
            <Col span={9}>
              <span>工事名</span>
            </Col>
            <Col span={15}>
              <span>{detailImage?.site_name}</span>
            </Col>
          </div>
          <div className="title-id-about">
            <Col span={9}>
              <span>工事コード</span>
            </Col>
            <Col span={15}>
              <span>{detailImage?.building_code}</span>
            </Col>
          </div>
          <div className="title-id-about">
            <Col span={9}>
              <span>工種</span>
            </Col>
            <Col span={15}>{!formik && !dataSite ? '' : <span>{dataSite}</span>}</Col>
          </div>
          {image ? (
            <div className="title-id-image">
              {!loading ? (
                <img className="title-id-image" src={convertImage} alt="" />
              ) : (
                <Skeleton.Button
                  className="skeleton"
                  active
                  style={{ width: 210, height: 110, maxWidth: '100%', opacity: '0.5' }}
                />
              )}
            </div>
          ) : (
            <div className="title-id-image">
              {!loading ? (
                <img className="title-id-image" src={convertImage} alt="" />
              ) : (
                <Empty
                  className="title-id-image-empty"
                  description="ここに写真が合成されます"
                  image={<img src={iconPhoto} alt="iconPhoto" />}
                  imageStyle={{
                    width: '22px',
                    height: '17px',
                    opacity: '0.5',
                    position: 'absolute',
                    left: '50%',
                    top: '60%',
                    transform: 'translate(-50%, -50%)',
                  }}
                />
              )}
            </div>
          )}
        </Row>
      </Card>
    </CardGraft>
  );
};

export default CardGraftDrop;
